const DEFAULT_FRACTION_DIGITS = 2;

export function formatCurrency(value: number, fractionDigits: number = DEFAULT_FRACTION_DIGITS) {
    return Number(value).toLocaleString(
        'en-UK', { style: 'currency', currency: 'GBP', minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
}